import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    data: null,
    message: null,
    error: null,
    territoryList: null,
    createStatus: null,
    updateStatus: null,
    deleteStatus: null,
}

const territorySlice = createSlice({
    name: 'territory',
    initialState,
    reducers: {
        getTerritoryStart: (state) => {
            state.isLoading = true;
            state.data = null;
            state.error = null;
            state.territoryList = null;
        },
        getTerritorySuccess: (state, action) => {
            state.data = action?.payload?.territoryMng;
            state.territoryList = action?.payload?.territoryMng;
            state.isLoading = false;
        },
        getTerritoryFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        createTerritoryStart: (state, action) => {
            state.isLoading = true;
            state.createStatus = null;
        },
        createTerritorySuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createStatus = action?.payload?.success;
        },
        createTerritoryFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createStatus = action?.payload?.success;
        },
        updateTerritoryStart: (state, action) => {
            state.isLoading = true;
            state.updateStatus = null;
        },
        updateTerritorySuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateStatus = action?.payload?.success;
        },
        updateTerritoryFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateStatus = action?.payload?.success;
        },
        deleteTerritoryStart: (state, action) => {
            state.isLoading = true;
            state.deleteStatus = null;
        },
        deleteTerritorySuccess: (state, action) => {
            state.isLoading = false;
            state.deleteStatus = action?.payload?.success;
        },
        deleteTerritoryFailure: (state, action) => {
            state.isLoading = false;
            state.deleteStatus = action?.payload?.success;
        },
        resetState: (state) => {
            state.isLoading = false;
            state.message = null;
            state.error = null;
            state.createStatus = null;
            state.updateStatus = null;
            state.deleteStatus = null;
        }
    }
});
export const {
    getTerritoryStart,
    getTerritorySuccess,
    getTerritoryFailure,
    createTerritoryStart,
    createTerritorySuccess,
    createTerritoryFailure,
    updateTerritoryStart,
    updateTerritorySuccess,
    updateTerritoryFailure,
    deleteTerritoryStart,
    deleteTerritorySuccess,
    deleteTerritoryFailure,
    resetState
} = territorySlice?.actions;

export default territorySlice?.reducer;